// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.container_psyhotest .test-info {
  padding: 0 30px;
  color: #818181;
  text-align: center;
  font-family: "Roboto-Light";
  font-size: 17px;
}
.container_psyhotest .test-info[data-active=false] {
  display: none;
}
.container_psyhotest .content .title_psyhotest {
  color: rgb(60, 60, 60);
  font-family: "Century Gothic";
  text-align: center;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 3rem;
}
@media screen and (max-width: 380px) {
  .container_psyhotest .content .title_psyhotest {
    padding: 0 20px;
    font-size: 1.4rem;
    line-height: 1.2em;
  }
}
.container_psyhotest .content .content_form_work {
  min-height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container_psyhotest .content .content_form_work .form_work {
  text-align: center;
  width: 50%;
}
.container_psyhotest .content .content_form_work .form_work .workpPlace {
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-color: transparent;
  border: none;
  border-radius: 0;
  font-family: "Roboto-Light";
  font-size: 0.9em;
  font-weight: 400;
  height: 50px;
  padding: 9px 25px;
  text-align: center;
  text-transform: uppercase;
}
@media screen and (max-width: 780px) {
  .container_psyhotest .content .content_form_work .form_work .workpPlace {
    font-size: 0.7em;
  }
}
@media screen and (max-width: 600px) {
  .container_psyhotest .content .content_form_work .form_work .workpPlace {
    font-size: 0.6em;
  }
}
.container_psyhotest .content .content_form_work .form_work .btn_form_work {
  margin: 30px;
  background-color: #91b61b;
  border: 2px solid #91b61b;
  border-radius: 0;
  color: #fff;
  display: inline-block;
  font-family: "Roboto-Regular", sans-serif;
  font-size: 0.9em;
  font-weight: 500;
  padding: 1.1em 2.5em;
  text-decoration: none !important;
  text-transform: uppercase;
}
.container_psyhotest .content .content_form_work .form_work .btn_form_work:hover {
  background-color: transparent;
  color: #91b61b;
}
.container_psyhotest .content .items_image {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}
@media screen and (max-width: 991px) {
  .container_psyhotest .content .items_image {
    grid-template-columns: repeat(1, 1fr);
  }
}
.container_psyhotest .content .items_image .item_image {
  position: relative;
  text-align: center;
}
@media screen and (max-width: 991px) {
  .container_psyhotest .content .items_image .item_image {
    max-width: 720px;
    margin: 0 auto;
  }
}
.container_psyhotest .content .items_image .item_image .image {
  width: 160px;
  height: 180px;
  cursor: pointer;
}
@media screen and (max-width: 991px) {
  .container_psyhotest .content .items_image .item_image .image {
    width: 60%;
    height: auto;
  }
}
.container_psyhotest .content .items_image .item_image .image:hover {
  transform: scale(1.1);
}
.container_psyhotest .content .items_image .item_image h4 {
  color: rgb(60, 60, 60);
  font-family: "Century Gothic";
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.3em;
  pointer-events: none;
}
.container_psyhotest .content .items_image .item_image .description {
  color: rgb(129, 129, 129);
  font-family: "Roboto-Light";
  text-align: center;
  font-size: 17px;
  font-weight: 300;
  line-height: 1.42em;
  pointer-events: none;
}
.container_psyhotest .content .items_text .item_text {
  margin: 10px 0;
  border: 1px solid rgb(60, 60, 60);
  cursor: pointer;
}
.container_psyhotest .content .items_text .item_text .description_text {
  margin: 0;
  padding: 20px 10px;
  color: rgb(129, 129, 129);
  font-family: "Roboto-Light";
  font-size: 17px;
  line-height: 1.42em;
}
.container_psyhotest .content .items_text .item_text:hover {
  background-color: rgb(145, 182, 27);
  border: 1px solid rgb(145, 182, 27);
}
.container_psyhotest .content .items_text .item_text:hover .description_text {
  color: rgb(255, 255, 255);
}
.container_psyhotest .test_form_text {
  font-family: "Century Gothic";
  color: rgb(60, 60, 60);
  font-size: 1.8rem;
  line-height: 3rem;
  font-weight: 600;
  text-align: center;
}
.container_psyhotest .content_form_test_phone {
  margin: 0 auto;
  width: 50%;
}
.container_psyhotest .content_form_test_phone .form_test_phone {
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  border-color: transparent;
  border: none;
  border-radius: 0;
  font-family: "Roboto-Light";
  font-size: 0.9em;
  font-weight: 400;
  height: 50px;
  padding: 9px 25px;
  text-align: center;
  text-transform: uppercase;
}
.container_psyhotest .content_form_test_phone .control_link {
  margin: 20px 0;
}
.container_psyhotest .result_test {
  text-align: center;
  color: rgb(129, 129, 129);
  font-family: "Roboto-Light";
  font-size: 1.5rem;
  font-weight: 300;
}
.container_psyhotest .container_button {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/PsyhoTest/PsyhoTest.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AARI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;AAUR;AAPI;EACI,aAAA;AASR;AAJQ;EACI,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAMZ;AAJY;EARJ;IASQ,eAAA;IACA,iBAAA;IACA,kBAAA;EAOd;AACF;AAJQ;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMZ;AAJY;EACI,kBAAA;EACA,UAAA;AAMhB;AAJgB;EACI,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAMpB;AAJoB;EAfJ;IAgBQ,gBAAA;EAOtB;AACF;AALoB;EAnBJ;IAoBQ,gBAAA;EAQtB;AACF;AALgB;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,yBAAA;AAOpB;AAJgB;EACI,6BAAA;EACA,cAAA;AAMpB;AADQ;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAGZ;AADY;EALJ;IAMQ,qCAAA;EAId;AACF;AAFY;EACI,kBAAA;EACA,kBAAA;AAIhB;AAFgB;EAJJ;IAKQ,gBAAA;IACA,cAAA;EAKlB;AACF;AAHgB;EACI,YAAA;EACA,aAAA;EACA,eAAA;AAKpB;AAFoB;EANJ;IAOQ,UAAA;IACA,YAAA;EAKtB;AACF;AAFgB;EACI,qBAAA;AAIpB;AADgB;EACI,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAGpB;AAAgB;EACI,yBAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAEpB;AAIY;EACI,cAAA;EAEA,iCAAA;EACA,eAAA;AAHhB;AAKgB;EACI,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;AAHpB;AAMY;EACI,mCAAA;EACA,mCAAA;AAJhB;AAMgB;EACI,yBAAA;AAJpB;AAWI;EACI,6BAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AATR;AAYI;EACI,cAAA;EACA,UAAA;AAVR;AAYQ;EACI,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,cAAA;AAXZ;AAeI;EACI,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;AAbR;AAgBI;EACI,aAAA;EACA,uBAAA;AAdR","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.container_psyhotest {\n    .test-info {\n        padding: 0 30px;\n        color: #818181;\n        text-align: center;\n        font-family: \"Roboto-Light\";\n        font-size: 17px;\n    }\n\n    .test-info[data-active=\"false\"] {\n        display: none;\n    }\n\n    .content {\n\n        .title_psyhotest {\n            color: rgb(60, 60, 60);\n            font-family: \"Century Gothic\";\n            text-align: center;\n            font-size: 1.8rem;\n            font-weight: 600;\n            line-height: 3rem;\n\n            @media screen and (max-width: 380px) {\n                padding: 0 20px;\n                font-size: 1.4rem;\n                line-height: 1.2em;\n            }\n        }\n\n        .content_form_work {\n            min-height: 250px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            .form_work {\n                text-align: center;\n                width: 50%;\n\n                .workpPlace {\n                    width: 100%;\n                    box-sizing: border-box;\n                    background-color: #fff;\n                    border-color: transparent;\n                    border: none;\n                    border-radius: 0;\n                    font-family: \"Roboto-Light\";\n                    font-size: 0.9em;\n                    font-weight: 400;\n                    height: 50px;\n                    padding: 9px 25px;\n                    text-align: center;\n                    text-transform: uppercase;\n\n                    @media screen and (max-width: 780px) {\n                        font-size: 0.7em;\n                    }\n\n                    @media screen and (max-width: 600px) {\n                        font-size: 0.6em;\n                    }\n                }\n\n                .btn_form_work {\n                    margin: 30px;\n                    background-color: #91b61b;\n                    border: 2px solid #91b61b;\n                    border-radius: 0;\n                    color: #fff;\n                    display: inline-block;\n                    font-family: \"Roboto-Regular\", sans-serif;\n                    font-size: 0.9em;\n                    font-weight: 500;\n                    padding: 1.1em 2.5em;\n                    text-decoration: none !important;\n                    text-transform: uppercase;\n                }\n\n                .btn_form_work:hover {\n                    background-color: transparent;\n                    color: #91b61b;\n                }\n            }\n        }\n\n        .items_image {\n            display: grid;\n            grid-template-columns: repeat(4, 1fr);\n            gap: 10px;\n\n            @media screen and (max-width: 991px) {\n                grid-template-columns: repeat(1, 1fr);\n            }\n\n            .item_image {\n                position: relative;\n                text-align: center;\n\n                @media screen and (max-width: 991px) {\n                    max-width: 720px;\n                    margin: 0 auto;\n                }\n\n                .image {\n                    width: 160px;\n                    height: 180px;\n                    cursor: pointer;\n                    // pointer-events: none;\n\n                    @media screen and (max-width: 991px) {\n                        width: 60%;\n                        height: auto;\n                    }\n                }\n\n                .image:hover {\n                    transform: scale(1.1);\n                }\n\n                h4 {\n                    color: rgb(60, 60, 60);\n                    font-family: \"Century Gothic\";\n                    text-align: center;\n                    font-size: 17px;\n                    font-weight: 600;\n                    line-height: 1.3em;\n                    pointer-events: none;\n                }\n\n                .description {\n                    color: rgb(129, 129, 129);\n                    font-family: \"Roboto-Light\";\n                    text-align: center;\n                    font-size: 17px;\n                    font-weight: 300;\n                    line-height: 1.42em;\n                    pointer-events: none;\n                }\n            }\n        }\n\n        .items_text {\n            .item_text {\n                margin: 10px 0;\n                // padding: 10px;\n                border: 1px solid rgb(60, 60, 60);\n                cursor: pointer;\n\n                .description_text {\n                    margin: 0;\n                    padding: 20px 10px;\n                    color: rgb(129, 129, 129);\n                    font-family: \"Roboto-Light\";\n                    font-size: 17px;\n                    line-height: 1.42em;\n                }\n            }\n            .item_text:hover {\n                background-color: rgb(145, 182, 27);\n                border: 1px solid rgb(145, 182, 27);\n\n                .description_text {\n                    color: rgb(255, 255, 255);\n                }\n            }\n\n        }\n    }\n\n    .test_form_text {\n        font-family: \"Century Gothic\";\n        color: rgb(60, 60, 60);\n        font-size: 1.8rem;\n        line-height: 3rem;\n        font-weight: 600;\n        text-align: center;\n    }\n\n    .content_form_test_phone {\n        margin: 0 auto;\n        width: 50%;\n\n        .form_test_phone {\n            width: 100%;\n            box-sizing: border-box;\n            background-color: #fff;\n            border-color: transparent;\n            border: none;\n            border-radius: 0;\n            font-family: \"Roboto-Light\";\n            font-size: 0.9em;\n            font-weight: 400;\n            height: 50px;\n            padding: 9px 25px;\n            text-align: center;\n            text-transform: uppercase;\n        }\n\n        .control_link {\n            margin: 20px 0;\n        }\n    }\n\n    .result_test {\n        text-align: center;\n        color: rgb(129, 129, 129);\n        font-family: \"Roboto-Light\";\n        font-size: 1.5rem;\n        font-weight: 300;\n    }\n\n    .container_button {\n        display: flex;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
